import '../render'
import '../../stylesheets/img.scss'

import ImageDiff from './lib/diff'
import ImageViewer from './lib/viewer'
import {onDocumentReady} from '../render/utils'
import Status from '../render/status'
import {RENDER_FORMATS} from '../render/constants'

function ImgRenderer() {
  const status = new Status(RENDER_FORMATS.image)
  const shell = document.querySelector<HTMLElement>('.js-render-shell div')!

  const isDiffing = shell.getAttribute('data-type') === 'diff'

  if (isDiffing) {
    new ImageDiff(shell, status)
  } else {
    new ImageViewer(shell, status)
  }
}

onDocumentReady(() => ImgRenderer())
